import {
  Button,
  Form,
  FormControl,
  FormGroup,
  FormLabel,
} from "@themesberg/react-bootstrap";
import React, { useState } from "react";
import { axiosInstance } from "../../../../config/axios";
import { APIURL } from "../../../../configApi";
import { NotificationManager } from "react-notifications";

const EditSousGroupe = (props) => {
  const { refreshGroupeList, sousgroupe } = props;
  const [sous_groupe_name, setSous_Groupe_Name] = useState(sousgroupe.name);
  const updateSGroupre = (e) => {
    e.preventDefault();
    axiosInstance
      .put(`${APIURL}/laboratory/sub_groups/${sousgroupe.id}`, {
        name: sous_groupe_name,
        group_id: sousgroupe.groupe_id,
      })
      .then((res) => {
        // console.log(res.data)
        NotificationManager.success(
          "Nom du sous-groupe modifié avec succès",
          "Notification"
        );
        refreshGroupeList();
        setSous_Groupe_Name("");
      })
      .catch((err) => {
        // console.log(err)
        NotificationManager.error(
          "Erreur lors de la modification d'un Sous-Groupe",
          "Notification"
        );
      });
  };

  return (
    <Form className={"d-flex align-items-end mb-3"} onSubmit={updateSGroupre}>
      <FormGroup className={"w-75 me-4"}>
        <FormLabel>Nom du sous-groupe</FormLabel>
        <FormControl
          type={"text"}
          placeholder={"Nom du sous-groupe ..."}
          value={sous_groupe_name}
          onChange={(e) => setSous_Groupe_Name(e.target.value)}
        ></FormControl>
      </FormGroup>
      <FormGroup className={"d-flex justify-content-end"}>
        <Button variant={"success"} className={"mt-3"} type={"submit"}>
          {" "}
          Modifier{" "}
        </Button>
      </FormGroup>
    </Form>
  );
};

export default EditSousGroupe;
